<script>

import ListingsFormNew from './ListingsFormNew';

export default {
  props: ['replacefilters', 'changefilters'],
  components: { ListingsFormNew },
  data() {
    return {
      dsbl_btn: false,
      
      show_filters: false,
      changes: false,

      dateRange: { startDate: null, endDate: null },
      search: '',
      stages: [
        {id: 'Awaiting Order', name: 'Awaiting Order', active: false},
        {id: 'Awaiting Forms', name: 'Awaiting Forms', active: false},
        {id: 'Awaiting Photos', name: 'Awaiting Photos', active: false},
        {id: 'Awaiting Signatures', name: 'Awaiting Signatures', active: false},
        {id: 'Awaiting Listing', name: 'Awaiting Listing', active: false},
        {id: 'Coming Soon', name: 'Coming Soon', active: false},
        {id: 'Active', name: 'Active', active: false},
        {id: 'Active Under Contract', name: 'Active Under Contract', active: false},
        {id: 'Pending', name: 'Pending', active: false},
        {id: 'Delete', name: 'Delete', active: false},
        {id: 'Expired', name: 'Expired', active: false},
        {id: 'Hold', name: 'Hold', active: false},
        {id: 'Incomplete', name: 'Incomplete', active: false},
        {id: 'Withdrawn', name: 'Withdrawn', active: false},
        {id: 'Canceled', name: 'Canceled', active: false},
        {id: 'Closed', name: 'Closed', active: false},
        {id: 'Trash', name: 'Trash', active: false},
      ],
      onmaps: [
        {value: '1', name: 'On map'},
        {value: '0', name: 'Not on map'},
        {value: '', name: 'On & Not on map'},
      ],
      property_types: [
        {name: 'Business Opportunity', id: 'Business Opportunity', active: false},
        {name: 'Commercial Lease', id: 'Commercial Lease', active: false},
        {name: 'Commercial Sale', id: 'Commercial Sale', active: false},
        {name: 'Farm', id: 'Farm', active: false},
        {name: 'Land', id: 'Land', active: false},
        {name: 'Manufactured In Park', id: 'Manufactured In Park', active: false},
        {name: 'Residential', id: 'Residential', active: false},
        {name: 'Residential Income', id: 'Residential Income', active: false},
        {name: 'Residential Lease', id: 'Residential Lease', active: false},
      ],
      referred_bys: [
        {id: 'phone call', name: 'Phone Call', active: false},
        {id: 'text message', name: 'Text Message', active: false},
        {id: 'television ad', name: 'Television Ad', active: false},
        {id: 'radio ad', name: 'Radio Ad', active: false},
        {id: 'internet ad', name: 'Internet Ad', active: false},
        {id: 'facebook', name: 'Facebook', active: false},
        {id: 'instagram', name: 'Instagram', active: false},
        {id: 'event', name: 'Event', active: false},
        {id: 'mail brochure', name: 'Mail - Brochure', active: false},
        {id: 'mail postcard', name: 'Mail - Postcard', active: false},
        {id: 'referral', name: 'Referral from another client', active: false},
        {id: 'repeat client', name: 'Repeat Client', active: false},
      ],
      
      loading: true,
      results: [],
      pagination: {},
      filters: {
        paginate: 50,
        page: 1,
        total: 0,
        selects: [
          'id',
          'user_id',
          'mls_id',
          'website',
          'on_map',
          'view_count',
          'mls_title',
          'ListingId',
          'StandardStatus',
          'PropertyType',
          'PropertySubType',
          'Address',
          'City',
          'StateOrProvince',
          'PostalCode',
          'Longitude',
          'Latitude',
          'ListingContractDate',
          'ExpirationDate',
          'PendingTimestamp',
          'CancellationDate',
          'CloseDate',
          'ListPrice',
          'ClosePrice',
          'YearBuilt',
          'SeniorCommunityYN',
          'AssociationYN',
          'WaterSource',
          'Sewer',
          'BuyerAgentFullName',
          'BuyerAgentEmail',
          'BuyerAgentOfficePhone',
          'TitleCompany',
          'MortgageCompany',
          'InsuranceCompany',
          'PhotosCount',
          'thumbnail',
          'referred_by',
          'referred_name',
          'savings_total',
          'estimated_total',
          'active_package',
          'mls_updated_at',
          'created_at',
          'updated_at',
        ],
        wheres: {
          on_map: '',
        },
        withs: {
          user: { total: 0, selects: ['id','name','email','phone','avatar'], norelations: 1, },
          carts: { total: 0, norelations: 1, },
        },
        whereins: {
          website: [],
          StandardStatus: [],
          mls_title: [],
          PropertyType: [],
        },
        wherehas: {
          user: {
            search: ['name','email','phone'],
          },
        },
        betweens: {
          created_at: {
            start: '',
            end: ''
          }
        },
        searchs: {
          search1: {
            value: ''
          }
        },
        orderbys: {

        },
      },

      mls_loading: true,
      mlss: [],
      mls_filters: {
        paginate: 100,
        page: 1,
        total: 0,
        selects: [
          'id',
          'title',
        ],
        wheres: {
          status: 1,
        },
      },

    }
  },
  watch: {
    'dateRange': { handler: function(n, o) {
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.created_at.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.created_at.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.created_at.start = '';
        this.filters.betweens.created_at.end = '';
      }
    }, deep: true },
    '$route.params.id': function (id) { if(!id) { console.log("Route param changed. Updating"); this.fetchData(); } },

    'loading': { handler: function(n, o) { this.$emit('loadchange', n) }},

    'filters.paginate': { handler: function(n, o) { this.pagination.current_page = 1; this.fetchData(); }},
  },
  created() {
    if(this.replacefilters) {
      this.filters = this.replacefilters;
    } else if(this.changefilters) {
      for(var i in this.changefilters) {
        this.filters[i] = this.changefilters[i];
      }
    }

    this.fetchData_mls();
    
    this.setWhereIns('mlss','filters','mls_title');
    this.setWhereIns('stages','filters','StandardStatus');
    this.setWhereIns('property_types','filters','PropertyType');
    this.setWhereIns('referred_bys','filters','referred_by');

    this.fetchData();
  },
  mounted() {
    window.addEventListener('scroll', this.setStickyNav);
    window.addEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').addEventListener('scroll', this.setStickyNav); }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setStickyNav);
    window.removeEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').removeEventListener('scroll', this.setStickyNav); }
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.filters.page = this.pagination.current_page;
      this.$http.get('/api/listings/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        this.results = res.data.data;
        this.pagination = res.data;
        this.filters.total = res.data.total;
        this.loading = false;
        this.changes = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
    fetchData_mls() {
      this.mls_loading = true;
      this.$http.get('/api/mlss/fetch', {params: this.mls_filters}).then(res => {
        // console.log(res);
        for(var i in res.data.data) { res.data.data[i].active = false; }
        this.mlss = res.data.data;

        // for(var i in this.mlss) { this.mlss[i].active = false; }
        this.filters.total = res.data.total;
        this.mls_loading = false;
      }).catch(res => { this.mls_loading = false; this.popupErrors(res); });
    },
    setWhereIns(items,filters,wherein) {
      var temp = [], all = true; for(var i in this[items]) { if(this[items][i].active) { temp.push(this[items][i].id); } else { all = false; } }

      var path = filters.split('.');
      var obj = this;
      for(var i in path) { obj = obj[path[i]]; }
      if(all) { obj.whereins[wherein] = ""; } else { obj.whereins[wherein] = temp; }
    },
    servicesCount(carts) {
      var output = 0;
      for(var i in carts) { if(carts[i].services) { output = output + carts[i].services.length; } }
      return output;
    },

  }
}
</script>

<template>


  <div>
    <transition name="fade">
      <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
    </transition>
    <div class="px-4 pt-4 pb-3">
      <div class="row">
        <div class="col-lg-8">
          <div class="form-inline">
            <button type="button" @click="fetchData()" class="btn btn-light mr-2 mb-2"><Icon icon="ri:refresh-line"></Icon></button>
            <div class="form-group mr-2 mb-2">
              <input type="text" class="form-control" placeholder="Search..." v-model="filters.searchs.search1.value" @change="changes = true">
            </div>
            <w-field class="mr-2 mb-2" SimpleDataType="String List, Multi" :Options="app_website_ids" v-model="filters.whereins.website" placeholder="Websites..." @input="changes = true"></w-field>
            <div class="form-group mr-2 mb-2">
              <button type="button" class="btn btn-primary dropdown-toggle" @click="show_filters ? show_filters = false : show_filters = true">Filters
                <Icon v-if="show_filters" icon="ri:arrow-drop-down-line"></Icon>
                <Icon v-else icon="ri:arrow-drop-right-line"></Icon>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="text-lg-right mt-3 mt-lg-0">
            <!-- <button type="button" @click="export_users()" class="btn btn-light ml-2" v-tippy content="Export to CSV file. Includes selected filters."><Icon icon="ri:download-cloud-2-line"></Icon></button> -->
            <button type="button" @click="$refs.modal_add_listing.show()" class="btn btn-success ml-2"><Icon icon="ri:add-line"></Icon> Add New</button>
          </div>
          <b-modal ref="modal_add_listing" centered size="xl" title="Create a new listing" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
            <div class="">
              <ListingsFormNew @hidemodel="(e) => { fetchData(); $refs.modal_add_listing.hide() }"></ListingsFormNew>
            </div>
          </b-modal>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div v-if="show_filters" class="form-inline px-2 pt-2 bg-gray-200">

         <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="String List, Single" v-model="filters.wheres.on_map" :Options="onmaps" placeholder="Filter by on map..." @input="changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2 position-relative">
          <button type="button" class="btn btn-white dropdown-toggle font-weight-500" data-toggle="dropdown">
            MLS: ({{mlss.filter(b=>{return b.active}).length}}/{{mlss.length}})
            <Icon icon="ri:arrow-down-s-line" />
          </button>
          <div class="dropdown-menu dropdown-menu-right" onclick="event.stopPropagation()">
            <div v-for="(item, index) in mlss" :key="item.id" class="dropdown-item">
              <p-check class="p-default p-curve p-smooth pretty-light w-100" color="success-o" v-model="item.active" @change="setWhereIns('mlss','filters','mls_title'); changes = true"> <span class="ml-1">{{item.title}}</span></p-check>
            </div>
          </div>
        </div>

        <div class="form-group mr-2 mb-2 position-relative">
          <button type="button" class="btn btn-white dropdown-toggle font-weight-500" data-toggle="dropdown">
            Stage: ({{stages.filter(b=>{return b.active}).length}}/{{stages.length}})
            <Icon icon="ri:arrow-down-s-line" />
          </button>
          <div class="dropdown-menu dropdown-menu-right" onclick="event.stopPropagation()">
            <div v-for="(item, index) in stages" :key="item.id" class="dropdown-item">
              <p-check class="p-default p-curve p-smooth pretty-light w-100" color="success-o" v-model="item.active" @change="setWhereIns('stages','filters','StandardStatus'); changes = true"> <span class="ml-1">{{item.name}}</span></p-check>
            </div>
          </div>
        </div>

        <div class="form-group mr-2 mb-2 position-relative">
          <button type="button" class="btn btn-white dropdown-toggle font-weight-500" data-toggle="dropdown">
            Property Type: ({{property_types.filter(b=>{return b.active}).length}}/{{property_types.length}})
            <Icon icon="ri:arrow-down-s-line" />
          </button>
          <div class="dropdown-menu dropdown-menu-right" onclick="event.stopPropagation()">
            <div v-for="(item, index) in property_types" :key="item.id" class="dropdown-item">
              <p-check class="p-default p-curve p-smooth pretty-light w-100" color="success-o" v-model="item.active" @change="setWhereIns('property_types','filters','PropertyType'); changes = true"> <span class="ml-1">{{item.name}}</span></p-check>
            </div>
          </div>
        </div>

        <div class="form-group mr-2 mb-2 position-relative">
          <button type="button" class="btn btn-white dropdown-toggle font-weight-500" data-toggle="dropdown">
            Referred by: ({{referred_bys.filter(b=>{return b.active}).length}}/{{referred_bys.length}})
            <Icon icon="ri:arrow-down-s-line" />
          </button>
          <div class="dropdown-menu dropdown-menu-right" onclick="event.stopPropagation()">
            <div v-for="(item, index) in referred_bys" :key="item.id" class="dropdown-item">
              <p-check class="p-default p-curve p-smooth pretty-light w-100" color="success-o" v-model="item.active" @change="setWhereIns('referred_bys','filters','referred_by'); changes = true"> <span class="ml-1">{{item.name}}</span></p-check>
            </div>
          </div>
        </div>
        
        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="Date range" v-model="dateRange" placeholder="Filter by date created..." @input="changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2">
          <select class="form-control" v-model="filters.paginate">
            <option value="50">Per page: (50)</option>
            <option value="100">Per page: (100)</option>
            <option value="250">Per page: (250)</option>
            <option value="500">Per page: (500)</option>
            <option value="750">Per page: (750)</option>
            <option value="1000">Per page: (1000)</option>
          </select>
        </div>

      </div>
    </transition>
    <transition name="fade">
      <div v-if="changes" class="alert alert-info rounded-0 m-0">Click <Icon icon="ri:refresh-line" /> commit any changes made to filters.</div>
    </transition>
    <div class="row">
      <div class="col-sm-12">
        <div class="table-responsive m-0">
          <table class="table table-small sticky-header table-bordered-right table-hover mb-0 table-centered text-nowrap">
            <thead class="bg-white">
              <tr>
                <th>Thumbnail</th>
                <th><tdsort coltext="Address" :orderby.sync="filters.orderbys.Address" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Stage" :orderby.sync="filters.orderbys.StandardStatus" @do="fetchData()"></tdsort></th>
                <th>User</th>
                <th><tdsort coltext="Website" :orderby.sync="filters.orderbys.website" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Package/Services" :orderby.sync="filters.orderbys.estimated_total" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="On Map" :orderby.sync="filters.orderbys.on_map" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Views" :orderby.sync="filters.orderbys.view_count" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="MLS" :orderby.sync="filters.orderbys.mls_title" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Listing ID" :orderby.sync="filters.orderbys.ListingId" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Property type" :orderby.sync="filters.orderbys.PropertyType" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="List date" :orderby.sync="filters.orderbys.ListingContractDate" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="List price" :orderby.sync="filters.orderbys.ListPrice" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Sold date" :orderby.sync="filters.orderbys.CloseDate" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Sold price" :orderby.sync="filters.orderbys.ClosePrice" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Referral type" :orderby.sync="filters.orderbys.referred_by" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Referred by" :orderby.sync="filters.orderbys.referred_name" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Buying agent" :orderby.sync="filters.orderbys.BuyerAgentFullName" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Title company" :orderby.sync="filters.orderbys.TitleCompany" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Mortgage company" :orderby.sync="filters.orderbys.MortgageCompany" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Insurance company" :orderby.sync="filters.orderbys.InsuranceCompany" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Updated on" :orderby.sync="filters.orderbys.updated_at" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
              </tr>
              <tr class="sticky-thead bg-white">
                <th>Thumbnail</th>
                <th><tdsort coltext="Address" :orderby.sync="filters.orderbys.Address" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Stage" :orderby.sync="filters.orderbys.StandardStatus" @do="fetchData()"></tdsort></th>
                <th>User</th>
                <th><tdsort coltext="Website" :orderby.sync="filters.orderbys.website" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Package/Services" :orderby.sync="filters.orderbys.estimated_total" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="On Map" :orderby.sync="filters.orderbys.on_map" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Views" :orderby.sync="filters.orderbys.view_count" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="MLS" :orderby.sync="filters.orderbys.mls_title" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Listing ID" :orderby.sync="filters.orderbys.ListingId" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Property type" :orderby.sync="filters.orderbys.PropertyType" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="List date" :orderby.sync="filters.orderbys.ListingContractDate" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="List price" :orderby.sync="filters.orderbys.ListPrice" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Sold date" :orderby.sync="filters.orderbys.CloseDate" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Sold price" :orderby.sync="filters.orderbys.ClosePrice" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Referral type" :orderby.sync="filters.orderbys.referred_by" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Referred by" :orderby.sync="filters.orderbys.referred_name" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Buying agent" :orderby.sync="filters.orderbys.BuyerAgentFullName" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Title company" :orderby.sync="filters.orderbys.TitleCompany" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Mortgage company" :orderby.sync="filters.orderbys.MortgageCompany" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Insurance company" :orderby.sync="filters.orderbys.InsuranceCompany" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Updated on" :orderby.sync="filters.orderbys.updated_at" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
              </tr>
            </thead>
            <tbody>
              <router-link v-for="(item, index) in results" :key="item.id" :to="'/listings/'+item.id" tag="tr" class="_c-pointer" exact>
                <td class="p-1" style="min-width:100px">
                  <router-link :to="'/listings/'+item.id">
                    <img v-if="item.thumbnail" :src="formatImage(item.thumbnail)" class="w-100">
                    <img v-else-if="item.Latitude && item.Longitude" :src="'https://maps.googleapis.com/maps/api/streetview?size=640x480&location='+eurl(item.Latitude+','+item.Longitude)+'&pitch=10&key='+google_key" class="w-100">
                    <img v-else src="@assets/images/no-image.jpg" class="w-100">
                  </router-link>
                </td>
                <td class="py-1">
                  <router-link :to="'/listings/'+item.id">
                    <div class="text-dark font-weight-bold">{{item.Address}}</div>
                    <div class="text-muted">{{item.City}} {{item.StateOrProvince}} {{item.PostalCode}}</div>

                    <span v-if="[
                      'Coming Soon',
                      'Active',
                      'Active Under Contract',
                      'Pending',
                      'Delete',
                      'Expired',
                      'Hold',
                      'Incomplete',
                      'Withdrawn',
                      'Canceled',
                      'Closed',
                    ].includes(item.StandardStatus)">
                      <Icon v-if="item.ListingId" icon="ri:building-2-line" class="text-success mr-2" v-tippy :content="'Connected to MLS automation. Last update on '+ moment(item.mls_updated_at).format('MM-DD-YYYY')" />
                      <Icon v-else icon="ri:building-2-line" class="text-danger mr-2" v-tippy content="Not connected to the MLS automation" />
                    </span>
                    <span v-else><Icon icon="ri:building-2-line" class="text-muted mr-2" v-tippy content="Not connected to the MLS automation. Must have a stage of Coming Soon or above to start automation." /></span>
                    <span class="mr-1" :class="item.PhotosCount > 0 ? 'text-success' : 'text-muted'" v-tippy :content="item.PhotosCount+' Photo(s) Uploaded'"><Icon icon="ri:camera-line" /> <small v-if="item.PhotosCount > 0">{{item.PhotosCount}}</small></span>
                    <Icon v-if="['Active','Active Under Contract','Pending','Closed'].includes(item.StandardStatus) && item.on_map && item.Latitude && item.Longitude" icon="ri:eye-line" class="text-success" v-tippy content="Shown on buy map page (If the map page is displaying listings directly instead of MLS listings)." />
                    <Icon v-else icon="ri:eye-off-line" class="text-danger" v-tippy content="Hidden from the buy map page. Listing must a stage of (Active, Active Under Contract, Pending, Closed), have the 'On map' setting enabled and have the Longitude/Latitude set to be displayed on the map page (If the map page is displaying listings directly instead of MLS listings)." />
                  </router-link>
                </td>
                <td>
                  <div v-if="item.StandardStatus == 'Awaiting Order'" class="alert alert-warning mb-0">Awaiting Order</div>
                  <div v-else-if="item.StandardStatus == 'Awaiting Forms'" class="alert alert-warning mb-0">Awaiting Forms</div>
                  <div v-else-if="item.StandardStatus == 'Awaiting Photos'" class="alert alert-warning mb-0">Awaiting Photos</div>
                  <div v-else-if="item.StandardStatus == 'Awaiting Signatures'" class="alert alert-warning mb-0">Awaiting Signatures</div>
                  <div v-else-if="item.StandardStatus == 'Awaiting Listing'" class="alert alert-warning mb-0">Awaiting Listing</div>
                  <div v-else-if="item.StandardStatus == 'Coming Soon'" class="alert alert-warning mb-0">Coming Soon</div>
                  <div v-else-if="item.StandardStatus == 'Active'" class="alert alert-success mb-0">Active</div>
                  <div v-else-if="item.StandardStatus == 'Active Under Contract'" class="alert alert-info mb-0">Active Under Contract</div>
                  <div v-else-if="item.StandardStatus == 'Pending'" class="alert alert-info mb-0">Pending</div>
                  <div v-else-if="item.StandardStatus == 'Delete'" class="alert alert-info mb-0">Delete</div>
                  <div v-else-if="item.StandardStatus == 'Expired'" class="alert alert-info mb-0">Expired</div>
                  <div v-else-if="item.StandardStatus == 'Hold'" class="alert alert-info mb-0">Hold</div>
                  <div v-else-if="item.StandardStatus == 'Incomplete'" class="alert alert-info mb-0">Incomplete</div>
                  <div v-else-if="item.StandardStatus == 'Withdrawn'" class="alert alert-info mb-0">Withdrawn</div>
                  <div v-else-if="item.StandardStatus == 'Canceled'" class="alert alert-info mb-0">Canceled</div>
                  <div v-else-if="item.StandardStatus == 'Closed'" class="alert alert-info mb-0">Closed</div>
                  <div v-else-if="item.StandardStatus == 'Trash'" class="alert alert-danger mb-0">Trash</div>
                  <div v-else class="alert alert-danger mb-0">Unknown</div>
                </td>
                <td>
                  <div v-if="item.user">
                    <div class="text-dark font-weight-bold">{{item.user.name}}</div>
                    <div class="text-muted">{{item.user.email}}</div>
                    <div class="text-muted">{{formatPhone(item.user.phone)}}</div>
                  </div>
                  <div v-else>
                    N/A
                  </div>
                </td>
                <td>{{item.website}}</td>
                <td class="small">
                  <div v-tippy :content="
                    `<div class='text-left _f-s-12'><strong>Package</strong><br>`+
                    (item.active_package ? `<span class='text-success'>`+formatPrice(item.active_package.price)+'</span> - '+item.active_package.title : 'Unknown')+
                    (item.carts ? `<br><strong>A La Carte Services</strong>`+item.carts.map(b => { return b.services.map(c => { return `<br><span class='text-success'>`+formatPrice(c.price)+'</span> - '+c.title; }) }) : '')+
                    '</div>'
                    ">
                    <div :class="item.estimated_total > 0 ? 'text-success' : ''"><strong>{{formatPrice(item.estimated_total)}}</strong></div>
                    <div>
                      {{(item.active_package ? item.active_package.title : 'Unknown')}}
                      + {{ item.carts ? servicesCount(item.carts) : 0 }} Service(s)
                    </div>
                    <div v-if="item.carts">{{item.carts.length}} Cart(s)</div>
                  </div>
                </td>
                <td>
                  <div v-if="item.on_map" class="alert alert-success mb-0">Yes</div>
                  <div v-else class="alert alert-danger mb-0">No</div>
                </td>
                <td>{{item.view_count}}</td>
                <td>{{item.mls && item.mls.title ? item.mls.title : item.mls_title ? item.mls_title : ''}}</td>
                <td>{{item.ListingId}}</td>
                <td>{{item.PropertyType}} <br> {{item.PropertySubType}}</td>
                <td><span v-if="moment(item.ListingContractDate).isValid()">{{moment(item.ListingContractDate).format('MM-DD-YYYY')}}</span></td>
                <td><span v-if="item.ListPrice && item.ListPrice > 0">{{formatPrice(item.ListPrice)}}</span></td>
                <td><span v-if="moment(item.CloseDate).isValid()">{{moment(item.CloseDate).format('MM-DD-YYYY')}}</span></td>
                <td><span v-if="item.ClosePrice && item.ClosePrice > 0">{{formatPrice(item.ClosePrice)}}</span></td>
                <td>{{item.referred_by}}</td>
                <td>{{item.referred_name}}</td>
                <td>{{item.BuyerAgentFullName}}</td>
                <td>{{item.TitleCompany}}</td>
                <td>{{item.MortgageCompany}}</td>
                <td>{{item.InsuranceCompany}}</td>
                <td><span v-if="moment(item.updated_at).isValid()">{{moment(item.updated_at).format('MM-DD-YYYY')}}</span></td>
                <td><span v-if="moment(item.created_at).isValid()">{{moment(item.created_at).format('MM-DD-YYYY')}}</span></td>
              </router-link>
            </tbody>
          </table>
          <div class="p-3 border-top border-light">
            <w-pagination :pagination="pagination" @paginate="results=[]; fetchData()" :offset="4"></w-pagination>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>
